<div class="settings-dialog-container  popup-container">
  <div class="settings-header">
    <span class="settings-title">{{ 'dialog.settings' | translate }}</span>
  </div>

  <div class="setting-list">
    <span (click)="openLanguageDialog()" matRipple>{{ 'dialog.languages' | translate }}</span>
    <span (click)="openInfoDialog()" matRipple>{{ 'dialog.information' | translate }}</span>
    <span (click)="sendSyncRequest()" matRipple>{{ 'dialog.sync' | translate }}</span>
    <span (click)="openBlacklist()" matRipple>Blacklist</span>
    <span (click)="openHistory()" matRipple>{{ 'dialog.history' | translate }}</span>
    <!--span (click)="logOut()" matRipple>{{ 'dialog.exit' | translate }}</span-->
  </div>

</div>